import { Navigate, useParams } from 'react-router-dom';

/**
 * Paths like /en-eg/area/products/:slug were matching /en-eg/:citySlug/products/:slug
 * with citySlug literally "area" (the areas section), producing wrong canonicals and
 * confusing Google Merchant / rich-result validation.
 */
export function RedirectMisnestedAreaProductToGlobal() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={slug ? `/products/${slug}` : '/products'} replace />;
}
